export default {
  error: {
    error_occured: "An error has occurred",
    reload_page: "Refresh the page",
    back: "Back",
    message: {
      not_found: "The page you were looking for was not found!",
      unavailable: "Service not available!",
      not_authorized_title: "Access not authorised",
      not_authorized: "You are not authorised to access this page",
      file_not_authorized: "You are not authorized to download a file",
      unauthenticated: "You must be logged in to access this page",
    },
    go_back_to_home: "Home",
    support_message:
      "A bug occurred during the operation you attempted to perform. Our teams have been notified and are working to resolve it. Thank you for your understanding.",
    login_attempts:
      "You have {attempts} attempts remaining. After that, your access will be suspended for 5 minutes as a security measure.",
    login_blocked:
      "Your account has been temporarily locked due to several failed login attempts. Please wait 5 minutes before trying again.",
  },
  warning: {
    title: "Advertencia : ",
  },
};
